module.exports = __webpack_public_path__ + "static/media/MasterChief.483e0d46.png";